import MemberProfile from './container';
export default MemberProfile;
